<app-sub-top-bar [setupObs]="layoutSetup" ></app-sub-top-bar>